import { AfterContentChecked, ChangeDetectorRef, Directive, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { untilDestroyed } from '@ngneat/until-destroy';
import { MbsPopupType, StepCondition } from 'mbs-ui-kit';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { Administrator } from 'mbs-ui-shared@models';
import { OnboardingButtonState } from 'wizards/onboarding/onboarding.constants';
import { StepsService } from 'wizards/onboarding/services/steps/steps.service';
import { StepType } from 'wizards/onboarding/services/steps/steps.types';
import { OnboardingMode } from 'wizards/services/onboarding/onboarding.constants';

@Directive()
export abstract class CommonView<StepId> implements AfterContentChecked {
  @Input() mode: OnboardingMode;
  @Input() back: EventEmitter<Record<string, unknown>>;
  @Input() next: EventEmitter<Record<string, unknown>>;
  @Output() finish = new EventEmitter<string>();
  @Output() updateBackButton = new EventEmitter<Partial<OnboardingButtonState>>();
  @Output() updateNextButton = new EventEmitter<Partial<OnboardingButtonState>>();

  public readonly stepCondition = StepCondition;
  public readonly mbsPopupType = MbsPopupType;
  public provider: Administrator;
  public b2CredentialsForm = this.fb.group({
    publicKey: ['', [Validators.required]],
    alreadyUsedAccounts: [[]],
    secretKey: ['', [Validators.required]],
    storageUnitName: [`cloudbackup${Math.floor(Math.random() * 100000000)}`]
  });
  public errorMessage = null;

  public get parentSteps(): { name: string; condition: StepCondition }[] {
    return this.stepsService.parentSteps.getValue();
  }

  public get currentStep(): StepType<StepId> {
    return this.stepsService.currentStep.getValue();
  }

  protected constructor(
    protected stepsService: StepsService<StepId>,
    public auth: AuthFacade,
    protected cdr: ChangeDetectorRef,
    public fb: FormBuilder
  ) {}

  public ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  public onTabClick(id: StepId): void {
    this.stepsService.transition(id);
  }

  protected initialize(): void {
    this.auth.currentUser$.pipe(untilDestroyed(this)).subscribe((provider) => (this.provider = provider));
  }

  public showAlert(message: string): void {
    this.errorMessage = message;
    setTimeout(() => (this.errorMessage = null), 5000);
  }

  public removeError() {
    this.errorMessage = null;
  }
}
